export default "skymp5-front/a12ebba80bb62ed5b5715017c3f7c921.png";